<template>
	<div
		id="missing-data-modal"
		class="modal fade"
		tabindex="1"
		aria-labelledby="missing-data-modal"
	>
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content p-4">
				<div class="modal-header position-relative">
					<h2 class="text-center pt-3 mb-0 text-2xl font-bold">
						ATENÇÃO!
					</h2>
					<div class="position-absolute ps-r--1 ps-t--3">
						<button
							id="close-modal"
							class="btn btn-light btn-sm m-2"
							@click="Close()"
						>
							<i class="fal fa-times"></i>
						</button>
					</div>
				</div>
				<div class="modal-body py-4">
					<div
						class="w-full h-full d-flex flex-column items-center justify-center gap-5"
					>
						<p class="text-warning">
							Por favor, preencha todos os campos obrigatórios
							para habilitar a funcionalidade de mensageria.
						</p>
						<form class="w-full h-56">
							<div class="form-group">
								<label>Nome fantasia</label>
								<input
									type="text"
									class="form-control"
									:value="organization.name"
									disabled
								/>
							</div>
							<div class="form-group">
								<label>Telefone</label>
								<input
									ref="phone"
									type="tel"
									class="form-control"
									:class="{
										'is-invalid': $v.phone.$error,
									}"
									v-model="$v.phone.$model"
									v-mask="[
										'(##) ####-####',
										'(##) #####-####',
									]"
									tabindex="2"
									autofocus
								/>
								<div
									v-if="!$v.phone.required"
									class="invalid-feedback"
								>
									Obrigatório
								</div>
								<div
									v-else-if="!$v.phone.minLength"
									class="invalid-feedback"
								>
									Número inválido
								</div>
							</div>
						</form>
					</div>
				</div>
				<div class="modal-footer px-0 flex justify-end">
					<button
						class="btn btn-primary"
						tabindex="3"
						@click="SavePhone"
					>
						Avançar
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { requiredIf, minLength } from 'vuelidate/lib/validators'
	export default {
		name: 'MissingDataModal',
		props: {
			organization: {
				type: Object,
				required: true,
			},
		},
		data() {
			return {
				phone: '',
			}
		},
		validations() {
			let obj = {
				phone: {
					required: requiredIf(() => {
						return this.phone === ''
					}),
					minLength: minLength(14),
				},
			}

			return obj
		},
		watch: {
			organization: {
				handler(organization) {
					this.phone =
						organization.phone_1 || organization.phone_2 || ''
				},
				immediate: true,
				deep: true,
			},
		},
		methods: {
			Open() {
				window.jQuery('#missing-data-modal').modal('show')
			},
			Close() {
				window.jQuery('#missing-data-modal').modal('hide')

				this.$emit('close')
			},
			SavePhone() {
				this.$v.phone.$touch()

				if (this.$v.phone.$invalid) return

				this.$emit('save', this.phone)
			},
		},
		async mounted() {
			this.Open()
			this.$v.phone.$touch()

			await this.$nextTick()

			setTimeout(() => {
				this.$refs.phone?.focus()
			}, 500)

			window.jQuery('#missing-data-modal').on('hidden.bs.modal', () => {
				window.jQuery('body').removeClass('modal-open')

				this.$emit('close')
			})
		},
	}
</script>

<style lang="scss" scoped></style>
